import { getIdToken } from '@/app/providers/FirebaseProvider'
import { type AuthProvider, getAuthProvider } from './authProviderStorage'
import { getAuthToken } from './authTokenStorage'

const getToken = async (provider: AuthProvider): Promise<string | null> => {
  if (['firebase', 'google'].includes(provider)) return await getIdToken()
  return getAuthToken(provider)
}

type AuthHeader = {
  authorization: string
  'x-auth-provider': AuthProvider
}
export const getAuthHeaders = async (): Promise<AuthHeader> => {
  const provider = getAuthProvider()
  if (!provider) throw new Error('no auth provider')

  const token = await getToken(provider)
  if (!token) throw new Error('not authenticated')

  return {
    authorization: `Bearer ${token}`,
    'x-auth-provider': provider,
  }
}
